<template>
  <div>
    <!-- 顶部banner -->
    <banner :image="require(`@/assets/solution/banner.jpg`)" :fontText="fontText" />
    <!-- 一 -->
    <div class="floor-solution">
      <div data-aos="fade-up">
        <div>
          <div class="title">
            产业互联网全景
          </div>
        </div>
        <div class="industry-container">
          <img src="@/assets/solution/floorOne.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 二 -->
    <floorTwo :retailArr="retailArr"/>
    <!-- 三 -->
    <div class="floor-solution floor-tab-height">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            平台核心能力
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            打造一个架构先进、功能齐全、体验良好的产业互联网运营平台
          </div>
        </div>
        <div class="tab-container" data-aos="fade-up">
          <div v-for="(item,index) in tabList" :key="index" @click="selectIndex=item.value" :class="{'active':selectIndex===item.value}" class="industry-item">
            {{
              item.name
            }}
          </div>
        </div>
        <div v-for="(item, index) in solutionTabList" :key="index" style="margin-top:25px" >
          <div v-if="selectIndex===index" class="solution-tab-item">
            <div  class="tab-item-left">
              <div class="tab-item-title">
                {{item.title}}
              </div>
              <div class="tab-item-content">
                {{item.content}}
              </div>
              <div v-for="(ele,idex) in item.childList" :key="idex">
                <div class="tab-item-child">
                  <img :src="ele.childImage" alt="">
                  <div>
                    <div class="tab-item-child-title">{{ele.childTitle}}</div>
                    <div class="tab-item-child-content">{{ele.childCont}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-item-right">
              <img :src="item.image" alt="">
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <!-- 四 -->
    <div class="floor-solution floorColor">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            产业互联网平台总体系统架构
          </div>
        </div>
        <div class="industry-container" data-aos="fade-up">
          <img src="@/assets/solution/floorTwo.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 五 -->
    <div class="floor-solution floor-tab-height1100">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            多角色高效业务协同
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            实现多角色之间的连接、互动与融合，实现多角色间的高效业务协同，构建全新产业价值网络，为各方获益
          </div>
        </div>
        <div class="industry-container" data-aos="fade-up">
          <img src="@/assets/solution/floorThr.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 六 -->
    <div class="floor-solution floorColor floor-tab-height840">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            精准、智能的供需匹配与推送
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            通过大量的供应商集中撮合，发挥平台极强的需求匹配功能，将最优势与竞争力的供应商及其产品匹配给采购方
          </div>
        </div>
        <div class="industry-container" data-aos="fade-up">
          <img src="@/assets/solution/floorFour.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 七 -->
    <div class="floor-solution-bg floor-tab-height750">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            仓储物流服务
          </div>
          <div style="font-size: 16px; color: #fff; line-height: 21px">
            集中各方资源，为采购商及供应商提供全面、细致的仓储、物流服务
          </div>
        </div>
        <div class="industry-container" data-aos="fade-up">
          <img src="@/assets/solution/floorFive.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 八 -->
    <div class="floor-solution floor-tab-height840">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            供应链金融服务
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 22px">
            依托交易平台对“四流”数据的掌控，并通过整合三方平台的企业信息，完成对客户的信用体系搭建，并结合物流的实时可控，确保资金使用的安全性<br/>
            同时客户通过资金的使用进行规模扩大，实现业务滚动增涨
          </div>
        </div>
        <div class="financial-container" data-aos="fade-up">
          <img src="@/assets/solution/floorSix.png" alt="" />
          <div class="financial-content">
            <div class="financial-content-item">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">应收账款融资</div>
                <div class="financial-item-content">将企业拥有的应收账款(即未来将收到的款项)以一定折扣率卖给金融机构，从而提前获得现金</div>
              </div>
            </div>
            <div class="financial-content-item">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">仓单抵押</div>
                <div class="financial-item-content">使用企业持有的库存作为担保，向金融机构获得贷款</div>
              </div>
            </div>
            <div class="financial-content-item">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">保理融资</div>
                <div class="financial-item-content">将企业应收账款出售给保理公司，由保理公司负责账款管理、催收和资金融通</div>
              </div>
            </div>
            <div class="financial-content-item">
              <img src="@/assets/solution/correctIcon.png" alt="" />
              <div>
                <div class="financial-content-title">保兑仓融资</div>
                <div class="financial-item-content">结合仓储服务的融资方式，将企业货物存放在第三方监管的仓库中，并以这些货物作为抵押获取贷款</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
// import Header from '../../components/Header'
import Footer from '../../components/Footer'
import banner from './components/banner'
import floorTwo from './components/floor2'
export default {
  name: "Solution",
  components: {
    floorTwo,
    Footer,
    banner,
  },
  data() {
    return {
      fontText: {
        title: '产业互联网平台解决方案',
        txtMiddle: [
          '构建全流程、端到端、全产业全链路、',
          '多行业的产业交易平台'
        ],
        flexrow: 1
      },
      retailArr: {
        title: '拥抱互联网，构建全新产业价值',
        text: '为企业带来新的增长机会，还能通过全链路的重塑实现降本增效，并最终打造出一个共享优势的产业生态',
        height: '390px',
        solutionList:[
          {
            image: require("@/assets/solution/numOne.png"),
            title: '拓展新机会，驱动增长',
            content: '通过网络化、数字化手段整合产业链上下游资源，帮助企业开拓新的业务模式和市场。',
          },
          {
            image: require("@/assets/solution/numTwo.png"),
            title: '全链路重塑，降本增效',
            content: '实现信息的实时流通和透明化管理，优化供应链管理，减少中间环节，降低交易成本。',
          },
          {
            image:require("@/assets/solution/numThr.png"),
            title:'打造产业生态，优势共享',
            content:'促进了不同企业和机构间的协作和资源共享，构建互利共赢的合作模式。',
          },
        ],
      },
      
      selectIndex: 0,
      tabList: [
        {
          value: 0,
          name: '智能制造'
        },
        {
          value: 1,
          name: '智慧供应链'
        },
        {
          value: 2,
          name: '智慧门店'
        },
      ],
      solutionTabList: [
        {
          title: '智能制造',
          content: '通过先进的信息技术、自动化技术和智能化技术，实现制造过程的数字化、网络化和智能化',
          image: require("@/assets/solution/tabBg1.jpg"),
          childList: [
            {
              childImage: require("@/assets/solution/tabOneIcon1.png"),
              childTitle: '生产自动化',
              childCont: '通过机器人、自动化设备等，实现生产过程的自动化，提高生产效率和产品质量。'
            },
            {
              childImage: require("@/assets/solution/tabOneIcon2.png"),
              childTitle: '数据采集与分析',
              childCont: '通过传感器、物联网等技术，实时采集生产过程中的各种数据，进行数据分析和挖掘，为生产决策提供支持。'
            },
            {
              childImage: require("@/assets/solution/tabOneIcon3.png"),
              childTitle: '智能调度与优化',
              childCont: '通过人工智能、大数据等技术，实现生产过程的智能调度和优化，降低生产成本，提高生产效率。'
            },
          ]
        },
        {
          title: '智慧供应链',
          content: '通过先进的信息技术、自动化技术和智能化技术，实现供应链的数字化、网络化和智能化',
          image: require("@/assets/solution/tabBg2.jpg"),
          childList: [
            {
              childImage: require("@/assets/solution/tabTwoIcon1.png"),
              childTitle: '供应链可视化',
              childCont: '供应链各环节的实时监控和可视化展示，提高供应链管理水平。'
            },
            {
              childImage: require("@/assets/solution/tabTwoIcon2.png"),
              childTitle: '需求预测与智能补货',
              childCont: '通过人工智能、大数据分析等技术，实现对市场需求的精准预测，并根据预测结果进行智能补货，降低库存成本。'
            },
            {
              childImage: require("@/assets/solution/tabTwoIcon3.png"),
              childTitle: '物流优化与智能调度',
              childCont: '物流过程的实时监控和智能调度，提高物流效率，降低物流成本。'
            },
          ]
        },
        {
          title: '智慧门店',
          content: '通过先进的信息技术、自动化技术和智能化技术，实现门店的数字化、网络化和智能化',
          image: require("@/assets/solution/tabBg3.jpg"),
          childList: [
            {
              childImage: require("@/assets/solution/tabThrIcon1.png"),
              childTitle: '客户识别',
              childCont: '通过人脸识别、大数据分析等技术，实现对客户的精准识别和个性化推荐，提高客户满意度和购买转化率。'
            },
            {
              childImage: require("@/assets/solution/tabThrIcon2.png"),
              childTitle: '智能导购与服务',
              childCont: '通过AI和大数据分析，为客户提供个性化的智能推荐和导购服务，提高客户购买满意度。'
            },
            {
              childImage: require("@/assets/solution/tabThrIcon3.png"),
              childTitle: '智能补货',
              childCont: '对商品的实时监控和管理，并根据销售情况进行智能补货，降低库存成本。'
            },
          ]
        },
      ]
    };
  },
  methods: {
    // 当鼠标进入元素时触发
    // handleMouseEnter(index) {
    //   // console.log('鼠标进入了元素' + index);
    //   this.industrySelecedIndex = index;
    // },
    // 当鼠标离开元素时触发
    // handleMouseLeave(index) {
    //   // console.log('鼠标离开了元素');
    // },
  },
};
</script>

<style lang="less" scoped>
.floor-solution {
  width: 100%;
  height: 920px;
  background: #fff;
}
.floor-solution .title{
  font-weight: bold; font-size: 32px; color: #222222;padding-top: 80px;margin-bottom: 14px;
}
.floor-solution .industry-container{
  padding-top: 35px;
  width: 1200px;
  margin: auto;
}
.floor-solution .industry-container img{
  width: 100%;
}

.floorColor{
  background: #F4F5FB;
}
.floor-cont-height{
  height: 750px;
}
.floor-solution .solution-container{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.floor-solution .solution-item{
  width: 380px;
  height: 360px;
  text-align: left;
  background: #FFFFFF;
  border-radius: 6px;
  overflow: hidden;
}
.floor-solution .solution-item-top{
 position: relative;
}
.floor-solution .solution-item-block{
  position: absolute;
  left: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.60), rgba(255, 255, 255, 1));
  width: 100%;
  height: 20px;
  border-radius: 6px 6px 0 0;
}
.floor-solution .solution-item-top img{
  width: 100%;
}
.floor-solution .solution-item-title{
  padding: 0 20px;
  color: #222222;
  font-size: 22px;
  font-weight: bold;
  line-height: 22px;
  margin-bottom: 20px;
  margin-top: 6px;
}
.floor-solution .solution-item-content{
  padding: 0 20px;
  font-size: 14px;
  color: #222222;
  line-height: 22px;
}

.floor-solution .tab-container{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 45px;
  font-size: 22px;
  color: #222222;
  line-height: 65px;
}
.tab-container .industry-item{
  cursor: pointer;
  box-sizing: border-box;
  width: 34%;
  border-bottom: 1px solid #CADBFF;
}
.tab-container .active{
  border-bottom: 4px solid #1763FF;
  font-weight: bold;
}
.floor-solution .solution-tab-item{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
}
.floor-solution .tab-item-right{
  width: 800px;
}
.floor-solution .tab-item-right img{
  width: 100%;
}
.floor-solution-bg{
  width: 100%;
  height: 920px;
  background: url('../../assets/solution/floorBg3.png') no-repeat center center;
  background-size: 1920px 100%;
  background-color: #0B4FD1; 
}
.floor-solution-bg .industry-container{
  padding-top: 35px;
  width: 1200px;
  margin: auto;
}
.floor-solution-bg .industry-container img{
  width: 100%;
}
.floor-solution-bg  .title{
  font-weight: bold; font-size: 32px; color: #FFFFFF;padding-top: 80px;margin-bottom: 14px;
}
.floor-tab-height{
  height: 1000px;
}
.floor-tab-height840{
  height: 840px;
}
.floor-tab-height750{
  height: 750px;
}
.floor-tab-height1100{
  height: 1100px;
}
.tab-item-left{
  text-align: left;
  width: 360px;
}
.tab-item-title{
  font-size: 22px;
  color: #222222;
  font-weight: bold;
  line-height: 22px;
  margin-top: 16px;
  margin-bottom: 10px;
}
.tab-item-content{
  font-size: 16px;
  color: #232323;
  line-height: 22px;
}
.tab-item-child{
  display: flex;
  margin-top: 15px;
  background: linear-gradient(0deg, rgba(250, 252, 255, 1), rgba(236, 242, 255, 1));
  padding: 25px;
  border-radius: 6px;
}
.tab-item-child img{
  width: 32px;
  height: 32px;
}
.tab-item-child-title{
  font-size: 18px;
  color: #222222;
  font-weight: bold;
  line-height: 28px;
  margin-left: 10px;
  margin-bottom: 10px;
}
.tab-item-child-content{
  color: #595859;
  font-size: 14px;
  line-height: 22px;
  margin-left: 10px;
}
.financial-container{
  width: 1200px;
  margin: auto;
  margin-top: 45px;
  display: flex;
  justify-content: space-between;
}
.financial-container img{
  width: 600px;
  height: 480px;
}
.financial-content{
  width: 560px;
}
.financial-content-item{
  text-align: left;
  display: flex;
}
.financial-content-item img{
  width: 22px;
  height: 16px;
  margin-top: 8px;
  margin-right: 10px;
}
.financial-content-title{
  color: #222222;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 14px;
}
.financial-item-content{
  color: #595859;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 36px;
}
</style>
